import React, { useEffect, useState } from 'react'
import Select from "react-select";
import ls from "local-storage";
import { useNavigate } from 'react-router-dom';
import { getBoothsById, getBoothsForBranch, getBranchById } from 'src/services/Booths/Booths';
import { Typography } from '@mui/material';
import { CCol } from '@coreui/react';

const BoothPicker = () => {

    const [booth, setBooth] = useState(ls.get("booth") ? {
        id:ls.get("booth").id, label:ls.get("booth").label ? ls.get("booth").label : ls.get("booth").id ,value:ls.get("booth").all ? ls.get("booth").all : ls.get("booth").id
    } : {
        id:"999", label:"Not Loaded",value:"not" 
    })

    const [boothOptions, setBoothOptions] = useState([])
    const navigate = useNavigate()

    const fetchDetails = async () => {
        let response = await getBoothsForBranch();

        if (response.success === 1) {
            let data = response?.data.map((item) =>{
                return {
                    id: item.id, 
                    label:`${item.name} - ${item.id}`,
                    value:item.id
                }
            }) ?? []

            if((localStorage.getItem('orgID') === "0" || JSON.parse(localStorage.getItem('userDetail'))?.org_id === 0)){
                data.unshift({
                    id: "0", 
                    label:"All Booths",
                    value:"all"
                })
            }

            if(booth.id === "999"){
                setBooth(data[0])
            }

            setBoothOptions(data)

        }
    }

    useEffect(() => {
        fetchDetails()
    }, [])


    async function handleChange(e){
        if(e.value !== "all"){
            setBooth(e)
    
            const data = await getBranchById(e.id)
    
            ls.set("booth", {id:e.id, label:e.label, ...data?.data[0]} ?? {})

            navigate(0)
            
        } else {
            let data = e
            
            data.value = "all"
            
            setBooth(data)
            ls.set("booth", data)
            navigate(0)
        }

    }

    return (
        <>
        <CCol style={{marginBottom:"2vh"}}>
            <Typography>Booth Picker:</Typography>
            <div
                    style={{
                        width: '200px',
                        zIndex: 99
                    }}
                >
                    <Select
                        placeholder="Pilih Cabang"
                        value={booth}
                        options={boothOptions}
                        onChange={(e) => {
                            handleChange(e)
                        }}
                        isDisabled={false}
                    />
                </div>
            </CCol>
        </>
    )
}

export default BoothPicker